import { CloseOutlined, ReloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useMemo } from "react";
import { sideBarFeatureEvent$ } from "../../api/eventBus";
import { eventBusType } from "../../config/Constant";
import { useAuthLayoutContext } from "../../context/AuthLayoutContext";
import { useMenuContext } from "../../context/MenuContext";
import { useSideBarStore } from "../../store/SideBarStore";
import { useInfoUser } from "../../store/UserStore";
import { useDirectoryContext } from "../select/directory/DirectoryContext";
import { QuickDirectory } from "../select/directory/QuickDirectory";

const SideBarOrganization = () => {
  const { languageMap } = useInfoUser();
  const { setIsOrganizationSideBar, isOrganizationSideBar } = useSideBarStore(
    (state) => state,
  );

  const { orgList, setOrgList } = useDirectoryContext();

  const { selectedConversation } = useMenuContext();

  const { fetchOrganizations, isTreeLoading } = useAuthLayoutContext();

  const handleRefreshOrganization = () => {
    // Fetch organization data again
  };

  const SidebarMenuStyle = useMemo(() => {
    if (!isOrganizationSideBar) {
      return "detail-chat-menu hidden";
    }

    if (!selectedConversation?.conversationId) {
      return "detail-chat-menu !block w-full";
    }

    return "detail-chat-menu";
  }, [selectedConversation?.conversationId, isOrganizationSideBar]);

  return (
    <div className={SidebarMenuStyle}>
      <div className="header justify-between">
        <div className="org-sidebar">
          {languageMap?.["menuOrg.title.organization"] ?? "Organization"}
        </div>
        <div className="flex items-center gap-2">
          {/* Refresh */}
          <Button
            type="text"
            icon={<ReloadOutlined />}
            onClick={handleRefreshOrganization}
            title="Refresh"
          />

          {/* Close */}
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={() => {
              setIsOrganizationSideBar(false);
              sideBarFeatureEvent$.next({
                type: eventBusType.CONVERSATION,
              });
            }}
            title="Close"
          />
        </div>
      </div>
      <div className="ml-[10px]">
        <QuickDirectory orgList={orgList} setOrgList={setOrgList} />
      </div>
    </div>
  );
};

export default SideBarOrganization;
